import { render, staticRenderFns } from "./SidebarGeography.vue?vue&type=template&id=b6cb0742&"
import script from "./SidebarGeography.vue?vue&type=script&lang=js&"
export * from "./SidebarGeography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports